export const products = {
  MSRP: "MSRP",
  LogInForPricing: "Log in for pricing",
  FilledOnSite: "Filled on-site",
  OnlyOnFullscript: "Only on Fullscript",
  Unit: "/ unit",
  WhatsInside: "What's inside",
} as const;
